import { render, staticRenderFns } from "./MerchantProfile.vue?vue&type=template&id=0bbcc6c6&"
import script from "./MerchantProfile.vue?vue&type=script&lang=js&"
export * from "./MerchantProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports